"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
const lodash_1 = __importDefault(require("lodash"));
class Contexter {
    constructor(...contexts) {
        this.contexts = [...(util_1.last(Contexter.curContexts) || []), ...contexts];
    }
    legate(block) {
        Contexter.curContexts.push(this.contexts);
        const r = block();
        Contexter.curContexts.pop();
        return r;
    }
    adopt(_child) {
        _child.contexter.prepend(this.contexts);
        return _child;
    }
    has(contextType) {
        return lodash_1.default.findIndex(this.contexts, c => c instanceof contextType) >= 0;
    }
    get(contextType) {
        const found = lodash_1.default.findLast(this.contexts, c => c instanceof contextType);
        return found || null;
    }
    use(contextType) {
        const c = this.get(contextType);
        if (!c)
            throw Error(`Context ${contextType} not set`);
        return c;
    }
    prepend(contexts) {
        const c = (contexts instanceof Contexter) ? contexts.contexts :
            (contexts instanceof Array) ? contexts :
                [contexts];
        this.contexts = [...c, ...this.contexts];
    }
}
exports.Contexter = Contexter;
Contexter.curContexts = [];
Contexter.DEFAULT = new Contexter();
// -----------------------------------------------------------------
// Usage example:
class MyContextType {
    constructor(s) {
        this.s = s;
    }
}
class X {
    constructor() {
        this.contexter = new Contexter(); // Gets the context from the stack
    }
    someMethod() {
        // Creating legate that will get passed on the Context
        this.contexter.legate(() => {
            // Code that creates legate, will automatically get a copy of parent contexts
        });
        // Reading the Context
        const c = this.contexter.get(MyContextType);
    }
}
